<div class="not-allowed">
  <mat-icon class="not-allowed__icon">block</mat-icon>
  <h1 class="not-allowed__title">{{ 'DEV_TOOLS_BLOCK.TITLE' | translate }}</h1>
  <p class="not-allowed__message">{{ 'DEV_TOOLS_BLOCK.MESSAGE' | translate }}</p>
</div>
